export const UPDATE_HOSTNAME = 'app/UPDATE_HOSTNAME';
export const UPDATE_AUTHCREDENTIALS = 'app/UPDATE_AUTHCREDENTIALS';
export const UPDATE_FRE = 'app/UPDATE_FRE';
export const UPDATE_ENABLECOLORS = 'app/UPDATE_ENABLECOLORS';
export const RESET_AUTHCREDENTIALS = 'app/RESET_AUTHCREDENTIALS';
